import React from 'react';
import DeleteIcon from '../../images/delete_icon.png';
import QRDownloadIcon from '../../images/qrDownload_icon.png';
import QRShowIcon from '../../images/QRview_icon.png';
import CopyIcon from '../../images/copyLink_icon.png'
import { withTranslation } from 'react-i18next';
import UserFileWarning from '../UserFileWarning/UserFileWarning';
import './FileElement.less'

class FileElement extends React.Component {
    static defaultProps = {
        data: null,
        editModelName: false,
        fileTooBig: false,
        setEditModelname: function(){},
        onClick: function(){},
        appAccess: false,
        canEdit: false,
        tempFileName: "",
        onChangeTempFileName: function(){},
        copyLink: function(){},
        onShowQRCode: function(){},
        deleteModel: function(){},
        downloadModelQRCode: function(){},
        updateInAppForModel: function(){},
        fileIndex: -1,
    };

    constructor(props) {
        super(props);

        this.state = {
        };
    }

    generateWarningMessage(data, appAccess){
        const { t } = this.props;
        if(data){
            let rapid = data.Rapid;

            if(rapid){
                if(appAccess){
                    //has rapid and app
                    return {title: t('ModelTooBigRapidAppTitle'), text: t('ModelTooBigRapidAppText')}
                }else{
                    // has rapid only
                    return {title: t('ModelTooBigRapidTitle'), text: t('ModelTooBigRapidText')}
                }
            }else if(appAccess){
                //has app only
                return {title: t('ModelTooBigAppTitle'), text: t('ModelTooBigAppText')}
            }
        }

        //has nothing
        return {title: t('ModelTooBigTitle'), text: t('ModelTooBigText')}
    }

    render() {
        const { t } = this.props;
        const props = this.props;
        const data = props.data;
        const fileTooBig = props.fileTooBig;
        const idx = props.fileIndex
        const warningMessage = this.generateWarningMessage(data, this.props.appAccess);
        
        return (
        <div className={fileTooBig ? 'user_file_element_filesize_warning' : 'user_file_element'}>
            <div className='user_file_element_section'>
                {props.editModelName !== idx &&
                    <label onClick={() => {props.setEditModelname(idx)}}>{data.Description}</label>
                }
                {props.editModelName === idx &&                                      
                    <input 
                    type="text" 
                    autoFocus 
                    onKeyDown={(e) => {if(e.code === "Enter"){
                        props.setEditModelname(-1, props.tempFileName);
                    }}} 
                    onBlur={() => props.setEditModelname(-1, props.tempFileName)}
                    value={props.tempFileName}
                    onChange={(e) => props.onChangeTempFileName(e.target.value)}
                    />                          
                }
                
                <label className='small_text'>{"(" + (new Date(data.Updated) == null ? "" : new Date(data.Updated).toLocaleDateString("de-DE")) + " " + t('ModelUpdated') + ")"}</label>
                <div className='user_file_element_row'>
                    <div className='user_file_element_row_element'>
                    <label>{t('ModelLink')}</label>
                    <button style={{padding: "0.3em 0.3em 0.1em 0.3em"}} title={t('ModelLinkTitle')} onClick={() => props.copyLink()}><img alt={t('ModelLinkTitle')} src={CopyIcon}></img></button>
                    </div>
                    <div className='user_file_element_row_element'>
                    <label>{t('QRCode')}</label>
                    <button style={{padding: "0.3em 0.3em 0.1em 0.3em"}} title={t('ViewQRCode')} onClick={() => props.onShowQRCode()}><img alt={t('ViewQRCode')} src={QRShowIcon}></img></button>
                    <button style={{padding: "0.3em 0.3em 0.1em 0.3em"}} title={t('Download')} onClick={() => props.downloadModelQRCode()}><img alt={t('Download')} src={QRDownloadIcon}></img></button>
                </div>
                </div>
            </div>
            <div className='user_file_element_section_right'>
                <div className={(props.appAccess === 1 && props.canEdit) ? 'user_file_element_section_top_edit' : 'user_file_element_section_top'}>
                    {props.appAccess === 1 && props.canEdit &&
                        <div className='user_file_element_section_input'><p>In App:  </p><label className="switch">
                        <input checked={data.InApp} onChange={(e) => props.updateInAppForModel(e.target.checked)} type="checkbox"></input>
                        <span className="slider round"></span>
                        </label>
                        </div>
                    }
                    <button className='section_delete' disabled={!props.canEdit} title={t('Delete')} onClick={() => props.deleteModel()}><img alt={t('Delete')} src={DeleteIcon}></img></button>
                </div>
                <div className='user_file_element_section_bottom'>
                    {fileTooBig && 
                        <UserFileWarning 
                            title={warningMessage.title}
                            text={warningMessage.text}
                        />}
                    <button title={t('OpenFile')} onClick={() => {props.onClick(props.data)/*this.setState({tempFileName : "", editModelName: false}); this.props.onClickOpenModel(data)}*/}} className='armodelviewer_button armodelviewer_button_fileopen'>{t('OpenFile')}</button>
                </div>
            </div>
        </div>
        )
    }
}

export default withTranslation()(FileElement);
